<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top> {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn>
    </v-snackbar>
    <ClientNav class="hideOnPrint"/>
    <v-row class="hideOnPrint" dense>
      <v-col cols="12" lg="3" xl="2">
        <ClientSide/>
      </v-col>
      <v-col cols="12" lg="9" xl="10">
        <v-card class="pa-2" outlined tile height="100%">
          <v-tabs v-model="activeTab" @change="getUpcomingEvents">
            <v-tab>Active Events</v-tab>
            <v-tab>Cancelled Events</v-tab>
          </v-tabs>
          <v-data-table
            :headers="currentHeaders"
            :items="currentEvents"
            sort-by="date"
            sort-desc
            :loading="isLoading"
            loading-text="Loading Upcoming Events"
            :search="search"
            height="auto">
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Events</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="search"
                  label="search"
                  class="desktop"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn
                  fab
                  small
                  @click="printTable()"
                  class="mr-8 mb-2 white--text"
                  color="#2b6993"
                  elevation="4"
                >
                  <v-icon>print</v-icon>
                </v-btn>
                <template>
                  <v-btn v-if="!isAuditorRole" color="#2b3990" dark class="mb-2" @click="showAdd()">
                    <v-icon left>add</v-icon>
                    Add Event
                  </v-btn>
                </template>
              </v-toolbar>
              <v-text-field
                v-model="search"
                clearable
                flat
                solo-inverted
                hide-details
                prepend-inner-icon="search"
                label="search"
                class="mobile ml-5 mr-5 mb-3 mt-3"
              ></v-text-field>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="viewEvent(item)">
                mdi-eye
              </v-icon>
              <v-icon small @click="showCancelModal(item)" v-if="!client && !isAuditorRole">
                mdi-cancel
              </v-icon>
            </template>
            <template v-slot:no-data>
              <v-btn color="#2b3990" class="white--text" @click="getUpcomingEvents()">Reset</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <h3>Cancel Event</h3>
        <v-textarea
          v-model="cancellationNote"
          placeholder="Enter cancellation reason (min 10 characters)"
          rows="4"
          cols="50"
        ></v-textarea>
        <div>
          <v-btn
            :disabled="cancellationNote.length < 10"
            @click="eventCancel"
          >Confirm
          </v-btn>
          <v-btn @click="closeModal">Close</v-btn>
        </div>
        <p v-if="cancellationNote.length > 0 && cancellationNote.length < 10">
          Note must be at least 10 characters (currently: {{ cancellationNote.length }})
        </p>
      </div>
    </div>

    <Foot class="hideOnPrint"/>

    <div id="printTable">
      <h2 class="text-center ma-3">Upcoming Events</h2>
      <v-row>
        <v-col cols="12" sm="12">
          <v-data-table
            :headers="headers"
            :items="events"
            sort-by="date"
            sort-desc
            :loading="isLoading"
            loading-text="Loading Upcoming Events"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Upcoming Events</v-toolbar-title>
              </v-toolbar>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>

    <div id="printItem">
      <h2 class="text-center ma-3">Upcoming Event</h2>
      <!-- <add-events-dialog
          :newEvent="newEvent"
          @on-add-event="onAddEvent"
          @on-update-event="onUpdateEvent"
          ref="event-dialog"
      /> -->
    </div>
  </div>

</template>

<script>
import axios from 'axios'
import ClientNav from '../../components/ClientNav'
import ClientSide from '../../components/ClientSide'
import Foot from '../../components/Footer'
import moment from 'moment'
import {displaySuccess, displayError} from "@/service/notification-message.service";
import DateTimeUtil from "../../../utils/date-time.util";

const url = require("../../client_config/config").url;

export default {
  components: {
    ClientNav,
    ClientSide,
    Foot,
  },
  data: function () {
    return {
      activeHeaders: [
        {
          text: 'Task',
          align: 'start',
          sortable: false,
          value: 'event',
        },
        {text: "Staff Assigned", value: "staffName"},
        {text: "Appointment Date and Time", value: "date"},
        {text: "Notes", value: "notes"},
        {text: "Actions", value: "actions", sortable: false},
      ],
      cancelledHeaders: [
        {
          text: 'Task',
          align: 'start',
          sortable: false,
          value: 'event',
        },
        {text: "Staff Assigned", value: "staffName"},
        {text: "Cancelled By", value: "cancellation.cancelledBy"},
        {text: "Cancellation Date", value: "cancellation.cancelledDate"},
        {text: "Cancellation Notes", value: "cancellation.cancelledNote"},
      ],
      dialog: false,
      editEvent: false,
      newEvent: true,
      msg: false,
      menu: false,
      signed: false,
      search: "",
      text: "",
      events: {
        active: [],
        cancelled: [],
      },
      users: [],
      tempData: [],
      userID: localStorage.getItem('userID'),
      clientID: this.$route.params.clientID,
      titleForm: "New Event",
      staff: "",
      eventID: "",
      newTask: "",
      newStaffAssigned: "",
      newNotes: "",
      newTransportation: "",
      newFrom: "",
      newTo: "",
      newDueDate: "",
      newTime: "",
      newDateCreated: new Date(),
      newCreatedBy: localStorage.getItem('Name'),
      newCompleted: "",
      editedIndex: -1,
      drsVisit: false,
      providers: [],
      client: false,
      editedItem: {
        task: "",
        staffAssigned: "",
        notes: "",
        transportation: "",
        DueDate: "",
        time: "",
        dateCreated: "",
        createdBy: "",
        completed: "",
      },
      defaultItem: {
        task: "",
        staffAssigned: "",
        notes: "",
        transportation: "",
        dueDate: "",
        time: "",
        dateCreated: "",
        createdBy: "",
        completed: "",
      },
      isLoading: true,
      taskList: [
        "Dr. Visit",
        "Family Visit",
        "Reminder",
        "Appointment",
        "Activity",
        "Menu",
        "Birthday",
        "Other"
      ],
      visitType: ["Primary Medical", "Psychiatry Medical", "Dental", "Vision", "Therapy", "Counseling",
        "Physical Therapy", "Instacare", "Emergency Room", "Endocrinology"],
      newVisitType: "",
      newProviderType: "",
      showModal: false,
      cancellationNote: '',
      selectedItem: null,
      activeTab: 0,
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex !== 1 ? "New Item" : "Edit Item";
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    },
    currentHeaders() {
      return this.activeTab === 0 ? this.activeHeaders : this.cancelledHeaders;
    },
    currentEvents() {
      console.log({activeTab: this.activeTab, events: this.events.active, cancelled: this.events.cancelled})
      return this.activeTab === 0 ? this.events.active : this.events.cancelled;
    }
  },


  created() {
    this.getUpcomingEvents();
    if (localStorage.getItem('userRole') === "Client") {
      this.client = true;
    }
  },

  methods: {
    initialize() {
      this.events = [];
    },

    validate() {
      return this.$refs.form.validate();
    },

    getUsers: function () {
      axios.get(`${url}/users`).then(async res => {
        this.users = res.data.users;
      });
    },
    addSignature: function () {
      if (!this.signed) {
        return this.newCompletedBy = ''
      }
      this.newCompletedBy = this.newCreatedBy + " - " + new Date();
      this.signed = true;
    },

    viewEvent(item) {
      this.$router.push({
        path: `/events/${this.clientID}/update-event/${item.id}`,
        query: {newEvent: 'false'}
      });
    },

    async getUpcomingEvents() {
      this.isLoading = true;

      try {
        if (this.activeTab === 0) {
          const response = await axios.get(`${url}/calendar/client/${this.clientID}`);
          console.log({responseActive: response.data});
          this.events.active = this.transformEventData(response.data.calendarEvents);

        } else {
          const response = await axios.get(`${url}/calendar/cancelled-events/client/${this.clientID}/`);
          console.log({responseCancel: response});
          this.events.cancelled = this.transformEventData(response.data);
        }
      } catch (error) {
        displayError(error.message || 'Error fetching events');
      } finally {
        this.isLoading = false;
      }
    },

    showAdd() {
      this.$router.push({
        path: `/events/${this.clientID}/add-event`,
        query: {newEvent: 'true'}
      });
    },

    showCancelModal(item) {
      this.selectedItem = item;
      this.cancellationNote = '';
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
      this.selectedItem = null;
      this.cancellationNote = '';
    },

    async eventCancel() {
      try {
        if (!this.cancellationNote || this.cancellationNote.length < 10) {
          displayError('Cancellation note must be at least 10 characters long');
          return;
        }

        const updatedItem = {
          ...this.selectedItem,
          note: this.cancellationNote
        };

        const response = await axios.put(`${url}/calendar/cancel`, updatedItem);

        if (response.status === 200 && response.data && response.data.msg) {
          displaySuccess("The event has been cancelled successfully.");
          this.closeModal();
          await this.getUpcomingEvents();
        } else {
          throw new Error('Unexpected response from server');
        }
      } catch (error) {
        console.error('Error in eventCancel:', error);
        const errorMsg = error.response?.data?.msg || error.message || 'Something went wrong.';
        displayError(errorMsg);
      } finally {
        console.log('Cancellation process completed');
        this.closeModal();
      }
    },

    getEvents() {
      this.isLoading = true;
      const events = [];
      axios.get(`${url}/calendar/client/${this.clientID}`).then(response => {
        this.events = [];
        response.data.calendarEvents.forEach(item => {
          const {Staff} = item;
          item.date = (item.StartDate === null) ? "" : moment(item.StartDate).format("YYYY-MM-DD HH:mma");
          item.StartDate = (item.StartDate === null) ? "" : item.StartDate;
          events.push({
            id: item._id,
            staff: item.Staff,
            staffName: Staff?.Name || '',
            program: item.Program,
            date: item.date,
            appointmentDate: item.StartDate,
            event: item.Event,
            notes: item.Notes,
            transportation: item.Transportation,
            newFrom: item.From,
            newTo: item.To,
            CreatedDate: item.CreatedDate,
            CreatedBy: item.CreatedBy,
            Signature: item.Signature,
            medicalVisit: item.MedicalVisit,
            client: item.Client,
            eventFor: item.EventFor,
          });
        });
      }).finally(() => {
        this.isLoading = false;
        this.events = events;
      });
    },

    createdBy: function () {
      this.newCreatedBy = this.staff
    },

    clear() {
      this.newTask = "";
      this.newStaffAssigned = "";
      this.newNotes = "";
      this.newTransportation = "";
      this.newDueDate = "";
      this.newFrom = "";
      this.newTo = "";
      this.newTime = "";
      this.newDateCreated = "";
      this.newCreatedBy = "";
      this.newCompleted = "";
    },

    printTable() {
      document.getElementById('printItem').style.display = "none";

      window.print()

    },

    printItem() {
      document.getElementById('printTable').style.display = "none";

      window.print()
    },

    close() {
      this.clear();
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    transformEventData(events) {
      return events.map(event => {
        let transformedEvent = {
          id: event._id,
          staff: event.Staff,
          staffName: event.Staff?.Name || '',
          program: event.Program,
          date: event.StartDate ? moment(event.StartDate).format("YYYY-MM-DD HH:mma") : "",
          appointmentDate: event.StartDate || "",
          event: event.Event,
          notes: event.Notes,
          transportation: event.Transportation,
          newFrom: event.From,
          newTo: event.To,
          CreatedDate: event.CreatedDate,
          CreatedBy: event.CreatedBy,
          Signature: event.Signature,
          medicalVisit: event.MedicalVisit,
          client: event.Client,
          eventFor: event.EventFor
        };

        // Conditionally add cancellation details if they exist
        if (event.cancellation) {
          transformedEvent.cancellation = {
            cancelledBy: event.cancellation.cancelledBy?.Name,
            cancelledNote: event.cancellation.note,
            cancelledDate: DateTimeUtil.toLocalDate(event.cancellation.cancelledAt)
          };
        }

        return transformedEvent;
      });
    }
  },
};
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }

}

#printTable {
  display: none;
}

#printItem {
  display: none;
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }

}

@media print {
  #printTable {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;

  }

  #printItem {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;


  }

  .hideOnPrint {
    display: none;
    border: none;
  }

  nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
    display: none;
    border: none;

  }

  @page {
    margin: 0;
  }

  body {
    margin: 1.6cm;
  }
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 5px;
  min-width: 300px;
}

textarea {
  width: 100%;
  margin: 10px 0;
}

button {
  margin: 0 5px;
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
